import inflection from 'inflection';
import React from 'react';
import { Link } from '../../utils/router/v3Bridge';
import postPath from '../../utils/url/postPath';
import styles from './ImportFilesConfirmation.module.scss';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const IMPORTED_FILES = gql(`
  fragment ImportFilesConfirmation_importedFiles on ImportedFile {
    filename
    post {
      id
      title
    }
  }
`);

interface ImportFilesConfirmationProps {
  importedFiles: DocumentType<typeof IMPORTED_FILES>[];
}

const ImportFilesConfirmation = ({
  importedFiles,
}: ImportFilesConfirmationProps) => {
  const succeeded = importedFiles.filter(({ post }) => !!post);
  const failed = importedFiles.filter(({ post }) => !post);
  const total = succeeded.length;

  if (total === 0) {
    return (
      <div>
        There was nothing found to import. Please check the file you uploaded.
      </div>
    );
  }

  return (
    <div>
      All done! We imported {total} {inflection.inflect('post', total)} for you.
      <div className={styles.section}>
        <ul>
          {succeeded.map(({ post }) => (
            <li key={post.id}>
              <Link to={postPath(post)} target="_blank">
                {post.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {failed.length ? (
        <div className={styles.section}>
          Failed to import:
          <ul>
            {failed.map(({ filename }) => (
              <li key={filename}> {filename} </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default ImportFilesConfirmation;
